import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const StatsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 13)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12h10.92M4.67 12V1H1v11M8.33 12V6.08H4.67V12M12 12V3.54H8.33V12" />
    </SVG>
  );
};
